export default __webpack_public_path__ + "static/Plots0007-aed571a03bd870ff741ee695d5918546.jpg";